import React from "react";
import { SBBox } from "modules/Commons";
import { useTranslation } from "react-i18next";
import { IProductModelAnalyserFilterProps } from "./models/IProductModelAnalyserFilterProps";
import { ITimeScope } from "domain/Domain/Models/ITimeScope";
import { IComposedFilter } from "domain/Utils";
import SBComposedFilter from "views/Commons/SBComposedFilter";

export default ({ onApply, initialDateRange }: IProductModelAnalyserFilterProps) => {
	const { t } = useTranslation();

	const handleApply = (obj: IComposedFilter) => {
		const picker = obj.picker;
		const filterItems = obj.filter || [];
		
		const selectedProduct = filterItems.find((c: any) => c.type === "product");
		const clientId = selectedProduct?.clientID || null;

		const selectedStore = filterItems.find((c: any) => c.type === "store");
		const storeClientId = selectedStore?.clientID || null;
		
		let selectedDateRange: ITimeScope | null = null;
		if (picker && picker.range && picker.range.startDate && picker.range.endDate) {
			selectedDateRange = {
				startDate: picker.range.startDate,
				endDate: picker.range.endDate
			} as ITimeScope;
		}

		onApply(clientId, storeClientId, selectedDateRange);
	};

	return (
		<SBBox mb={2}>
			<SBComposedFilter.Base
				filterRequired={false}
				dateRangeRequired={false}
				onApply={handleApply}
			>
				<SBComposedFilter.Picker startDate={initialDateRange?.startDate} endDate={initialDateRange?.endDate} />
				<SBComposedFilter.Filter useFiltersOptions={['product', 'store']} solo={true} />
				<SBComposedFilter.Applicator />
			</SBComposedFilter.Base>
		</SBBox>
	);
};

